package org.teddapp.project.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/** Un des deux choix d'une [TeddDecision]. */
class DecisionOption(val title: String, val hint: String? = null)

/**
 * Bascule de décision : deux choix de même taille et de même couleur, côte à côte
 * (ou empilés si [stacked]). Le design ne prend pas parti : céder / traverser, besoin / désir.
 */
@Composable
fun TeddDecision(
    first: DecisionOption,
    second: DecisionOption,
    onFirst: () -> Unit,
    onSecond: () -> Unit,
    modifier: Modifier = Modifier,
    stacked: Boolean = false,
) {
    if (stacked) {
        Column(modifier = modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            DecisionCard(first, onFirst, Modifier.fillMaxWidth())
            DecisionCard(second, onSecond, Modifier.fillMaxWidth())
        }
    } else {
        Row(modifier = modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp)) {
            DecisionCard(first, onFirst, Modifier.weight(1f))
            DecisionCard(second, onSecond, Modifier.weight(1f))
        }
    }
}

@Composable
private fun DecisionCard(option: DecisionOption, onClick: () -> Unit, modifier: Modifier) {
    val shape = RoundedCornerShape(TeddTokens.RMd)
    Column(
        modifier = modifier
            .clip(shape)
            .background(TeddTokens.Surface, shape)
            .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = onClick)
            .padding(horizontal = 14.dp, vertical = 16.dp),
    ) {
        Text(option.title, style = TeddType.Heading, color = TeddTokens.Ink)
        if (option.hint != null) {
            Spacer(modifier = Modifier.height(4.dp))
            Text(option.hint, color = TeddTokens.InkMuted, fontSize = 12.sp)
        }
    }
}
